import { Panel } from '../business-entities/panel.class';
import { Step } from '../business-entities/step.class';
import * as Enums from './enums';

export const findCarSectionConstant = {
    registrationNumberSection: 'registrationNumberSection',
    forgetRegPhoneNumberSection: 'forgetRegPhoneNumberSection',
    carSelectionSingle: 'carSelectionSingle',
    carSelectionMultiple: 'carSelectionMultiple',
    forgetRegOtpSection: 'forgetRegOtpSection'
};

export const contactInfoSectionConstant = {
    registrationNumberSection: 'registrationNumberSection',
    customerDetailSection: 'customerDetailSection',
    regOtpSection: 'regOtpSection',
};

export const selectWorkshopSectionConstant = {
    dateTimeSelection: 'dateTimeSelection',
    additonalServiceSection: 'additonalServiceSection',
    finalSummarySection: 'finalSummarySection'
};

export const stepsInitialData: Step[] = [
    new Step(1, false, true, 'fas fa-car', 'lblFindYourCar'),
    new Step(2, false, false, 'fas fa-cogs', 'lblSelectServices'),
    new Step(3, false, false, 'fas fa-calendar-alt', 'lblSelectDealer&Date'),
    new Step(4, false, false, 'fas fa-clipboard-check', 'lblSummary'),
    new Step(5, false, false, 'fas fa-id-badge', 'lblContactInfo')
];

export const panelInitialData: Panel[] = [
    new Panel(Enums.PanelIds.Panel1, 1, 'lblFindYourCar', null, true, false),
    new Panel(Enums.PanelIds.Panel2, 2, 'lblSelectServices', null, false, false),
    new Panel(Enums.PanelIds.Panel3, 3, 'lblSelectDealer&Date', null, false, false),
    new Panel(Enums.PanelIds.Panel4, 4, 'lblSummary', null, false, false),
    new Panel(Enums.PanelIds.Panel5, 5, 'lblContactInfo', null, false, false)
];

export const applicationPaths = Object({
  cookiePolicy: 'cookiePolicy'
});

